import { assign } from 'lodash';
import * as actions from '../constants';

const initialState = {
  isFetching: false,
  didInvalidate: false,
  error: false,
  year: new Date().getFullYear(),
  month: new Date().getMonth(),
  day: false,
  monthEvents: {
    holidays: [],
  },
  dayEvents: {
    holidays: [],
  },
  lastUpdated: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.REQUEST_HISTORY_MONTH:
      return assign({}, state, {
        isFetching: true,
        error: false,
        monthEvents: initialState.monthEvents,
        year: action.year,
        month: action.month,
      });

    case actions.RECEIVE_HISTORY_MONTH:
      return assign({}, state, {
        isFetching: false,
        didInvalidate: action.error !== false,
        error: action.error,
        monthEvents:
          action.error === false && action.data
            ? action.data
            : initialState.monthEvents,
        lastUpdated: action.error === false ? action.date : state.lastUpdated,
      });

    case actions.REQUEST_HISTORY_DAY:
      return assign({}, state, {
        isFetching: true,
        error: false,
        dayEvents: initialState.dayEvents,
        year: action.year,
        month: action.month,
        day: action.day,
      });

    case actions.RECEIVE_HISTORY_DAY:
      return assign({}, state, {
        isFetching: false,
        didInvalidate: action.error !== false,
        error: action.error,
        dayEvents:
          action.error === false && action.data
            ? action.data
            : initialState.dayEvents,
        lastUpdated: action.error === false ? action.date : state.lastUpdated,
      });

    default:
      return state;
  }
};
